import { QueryClient } from "@tanstack/react-query";
import { paperInventoryBussiness } from "api/bussiness/paper-material/paper-inventory";
import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { createQuery, useStaticQuery } from "./ultilities/base-query";
import {
  buildCatalogCacheKey,
  invalidateCatalogCache,
} from "./ultilities/catalog-cache-key";

export type PaperCatalogRecord = {
  code: string;
  specificationSize: string;
  brand: string;
  rollNumber: string;
  type: string;
  gsm: string;
};

export const PAPER_CATALOG_CACHE_KEY = buildCatalogCacheKey("paper");

const normalizeValue = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const fetchPaperCatalog = async (): Promise<PaperCatalogRecord[]> => {
  const res = await paperInventoryBussiness.getPapersInventory({
    filter: "",
    maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
    skipCount: 0,
    sorting: "",
    showZeroQuantity: true,
  });

  const records: PaperCatalogRecord[] = [];

  for (const item of res.items ?? []) {
    const base = {
      code: normalizeValue(item.material?.code),
      specificationSize: normalizeValue(item.material?.specificationSize),
      type: normalizeValue(item.material?.type),
      gsm: normalizeValue(item.material?.gsm),
    };

    const groupedItems = item.groupedItems?.length
      ? item.groupedItems
      : [{ brand: "", rollNumber: "" }];

    for (const groupedItem of groupedItems) {
      records.push({
        ...base,
        brand: normalizeValue(groupedItem.brand),
        rollNumber: normalizeValue(groupedItem.rollNumber),
      });
    }
  }

  return records;
};

export const usePaperCatalogCache = () => {
  return useStaticQuery(PAPER_CATALOG_CACHE_KEY, fetchPaperCatalog);
};

export const prefetchPaperCatalogCache = async (queryClient: QueryClient) => {
  await queryClient.prefetchQuery(
    createQuery(PAPER_CATALOG_CACHE_KEY, fetchPaperCatalog, "static"),
  );
};

export const invalidatePaperCatalogCache = async (queryClient: QueryClient) => {
  await invalidateCatalogCache(queryClient, "paper");
};
